import { Platform } from 'react-native';

import { getFont } from '@24i/nxg-sdk-higgs';
import { Theme } from '@24i/nxg-sdk-photon';
import { getDefaultVerticalSpacing, getWebResponsivePadding } from './utils';
import type { SectionSpacing } from './types';

const getSectionWrapperStyles = (
    theme: Theme,
    spacing?: SectionSpacing,
    useDefaultPadding = true
) => {
    // All keys are guaranteed present by useSectionRenderOptions
    const { top = 0, right = 0, bottom, left = 0, between = 0 } = spacing || {};

    // Use default vertical spacing if not explicitly set
    const finalBottom = bottom ?? getDefaultVerticalSpacing();

    const container = {
        marginTop: top,
        marginBottom: finalBottom,
        // On web: use centralized responsive padding
        // Mode from config: 'horizontal' (default, Grid) or 'left' (SingleRow, Slider)
        // On native: use explicit left/right values from spacing config
        ...(Platform.OS === 'web' && useDefaultPadding !== false
            ? getWebResponsivePadding(spacing?.webPaddingMode ?? 'horizontal')
            : { paddingLeft: left, paddingRight: right }),
    };

    return {
        container,
        header: {
            marginBottom: between,
        },
        titleContainer: {
            width: '100%',
            flexDirection: 'row' as const,
            alignItems: 'center' as const,
            flex: 1,
            paddingBottom: Platform.select({
                web: 20,
                default: Platform.isTV ? 16 : 12,
            }),
            paddingRight: 8,
        },
        content: {},
        title: {
            paddingRight: 8,
            left: 0,
            display: 'flex' as const,
            alignItems: 'center' as const,
            flexShrink: 1,
            ...getFont(theme, 'h3'),
            color: theme.color.textPrimary,
        },
        subtitle: {
            fontSize: 14,
            color: '#888',
        },
        seeAllButtonTitle: {
            transition: '0.35s ease-in-out',
            width: '100%',
            alignItems: 'center' as const,
            justifyContent: 'center' as const,
            display: 'flex' as const,
            color: theme.color.textPrimary,
            ...getFont(theme, 'body2'),
        },
        seeAllButtonContainer: {
            flexDirection: 'row-reverse' as const,
            transition: '0.35s ease-in-out',
            width: 24,
            height: 24,
            borderRadius: 12,
            alignItems: 'center' as const,
            backgroundColor: theme.color.lighterBlur1?.color,
            overflow: 'hidden' as const,
        },
        seeAllHovered: {
            width: '100%',
            paddingLeft: 8,
            paddingRight: 2,
        },
    };
};

export default getSectionWrapperStyles;
